import { DataSourceExecutionEvent, LookupModelSearchEvent, LookupModelSelectionEvent } from "@mcleod/components";
import { AutogenLayoutEdiImagingConfigSlideout } from "./autogen/AutogenLayoutEdiImagingConfigSlideout";
import { setQuickInfo } from "./DataFusionUtil";
import { CommonDialogs } from "@mcleod/common";
import { createCustomizationSlideout } from "./EdiUtility";

export class EdiImagingConfigSlideout extends AutogenLayoutEdiImagingConfigSlideout {
    private _parent_id: string = "";
    private _current_ids: string[] = [];

    async onDisplay(event: DataSourceExecutionEvent) {
        await this.setQuickInfos();
    }

    beforeExecution(event: DataSourceExecutionEvent) {
        this.mainDataSource?.activeRow?.set("parent_id", this.parentId);
    }

    async onImageTypeDropdownSelection(event: LookupModelSelectionEvent) {
        if (event.hasSelection()) {
            if (this.currentIds.includes(event.getValueFromSelectedRow("id"))) {
                this.mainDataSource?.activeRow?.set("image_type", null);
                await CommonDialogs.showDialog("The image type specified already exists in this profile.");
            } else {
                this.mainDataSource?.activeRow?.set("image_description", event.selection.get("img_dir_local"));
            }
        }
    }

    private async setQuickInfos() {
        const quickInfoMappings = [
            { field: "alt_img_comm", component: this.textboxAltImgComm, layout: "lme/datafusion/EdiCommControlQuickInfo" }
        ];

        quickInfoMappings.forEach(async ({ field, component, layout }) => {
            const value = this.mainDataSource?.activeRow?.get(field);
            if (value) {
                setQuickInfo(value, component, layout);
            }
        });
    }

    textboxAltImgCommOnLookupModelSearch(event: LookupModelSelectionEvent) {
        if (event.hasSelection()) {
            if (event.getValueFromSelectedRow("id")) {
                setQuickInfo(event.getValueFromSelectedRow("id"), this.textboxAltImgComm, "lme/datafusion/EdiCommControlQuickInfo");
            }
        }
    }

    textboxAltImgCommBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.direction = "O";
    }

    buttonCustomizeImageFileNameOnClick() {
        createCustomizationSlideout(
            "lme/datafusion/EdiCustomFilename",
            "Customize Custom Image Filename",
            this.mainDataSource,
            "custom_filename",
            "fileMask",
            true,
            this.mainDataSource?.activeRow?.get("next_batch") ?? 0
        );
    }

    public get parentId(): string {
        return this._parent_id;
    }

    public set parentId(value: string) {
        this._parent_id = value;
    }

    public get currentIds(): string[] {
        return this._current_ids;
    }

    public set currentIds(value: string[]) {
        this._current_ids = value;
    }
}
